"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.Root = exports.QrRoot = exports.QrCodeContainer = exports.CarouselWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _presentationUtils = require("@ori/presentation-utils");
var _models = require("../../models");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(3)
}));
const QrRoot = exports.QrRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  backgroundColor,
  size
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor,
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  width: `calc(${size}px + ${theme.spacing(8)})`,
  borderRadius: theme.shape.largeComponentRadius
}));
const StyledTitle = exports.StyledTitle = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['textPosition'])
})(({
  theme,
  textPosition
}) => ({
  color: theme.palette.text.primary,
  order: textPosition === _models.QRTextPosition.Bottom ? 3 : 0
}));
const QrCodeContainer = exports.QrCodeContainer = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  size
}) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.largeComponentRadius,
  backgroundColor: theme.palette.common.white,
  order: 2,
  height: `calc(${size}px + ${theme.spacing(2)})`
}));
const CarouselWrapper = exports.CarouselWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  numberOfSlides
}) => ({
  [`& .${_presentationComponents.carouselClasses.root}`]: {
    minWidth: `calc(${numberOfSlides * _presentationComponents.SHADES_SIZE_CURRENT}px + ${_presentationProductDetail.SPACING * numberOfSlides}px)`
  }
}));
